module.exports = __webpack_public_path__ + "images/overlay-77aeaa52715b898b73c74d68c630330e.png";